import { render, staticRenderFns } from "./MajorityFilter.vue?vue&type=template&id=050c57a4&scoped=true&"
import script from "./MajorityFilter.vue?vue&type=script&lang=js&"
export * from "./MajorityFilter.vue?vue&type=script&lang=js&"
import style0 from "./MajorityFilter.vue?vue&type=style&index=0&id=050c57a4&prod&scoped=true&lang=scss&"
import style1 from "./MajorityFilter.vue?vue&type=style&index=1&id=050c57a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c57a4",
  null
  
)

export default component.exports